import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { CouponFormValues } from "src/models/Coupon.model";
import CouponForm from "../Layouts/CouponForm";
import {
  useEditCouponMutation,
  useViewCouponByIdQuery,
} from "src/services/CouponServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";
import moment from "moment";
type Props = {
  onClose: () => void;
  couponId: string;
};

const EditCouponFormWrapper = ({ onClose, couponId }: Props) => {
  const [couponData, setCouponData] = useState<any>();

  const [editCoupon] = useEditCouponMutation();
  // Form Initial Values
  const { data, isLoading, isFetching } = useViewCouponByIdQuery(couponId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setCouponData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  const initialValues: CouponFormValues = {
    coupon_code: couponData?.couponCode,
    vaild_from: couponData?.startDate,
    valid_till: couponData?.endDate,
    max_apply_count: couponData?.maxAppliedCount,
    Student_name: couponData?.student?.map((el: any) => {
      return {
        label: el?.name,
        value: el?._id,
      };
    }),
    coupon_type: couponData?.couponType,
    type: couponData?.amountType,
    maxDiscountAmount: couponData?.maxDiscountAmount,
    discountAmount: couponData?.discountAmount,
    startTime: couponData?.startTime
      ? moment(couponData?.startTime?.split("-")?.[0]?.trim(), "hh:mm A")
      : null,
    endTime: couponData?.endTime
      ? moment(couponData?.endTime?.split("-")?.[0]?.trim(), "hh:mm A")
      : null,
  };

  // Validation Schema
  const validationSchema = object().shape({
    coupon_code: string().required("Please enter Coupon Code"),
    coupon_type: string().required("Please enter Coupon Type"),
    type: string().required("Please Select Type"),
    discountAmount: string()
      .test("type", "", (value, context) => {
        if (context.parent?.type === "PERCENTAGE") {
          if (Number(value) > 100 || Number(value) < 0) {
            return context.createError({
              message: "Cannot be greater than 100%",
              path: context.path,
            });
          }
          return true;
        } else {
          return true;
        }
      })
      .required("Please enter discount amount "),
  });

  // Handle Submit
  const handleSubmit = (
    values: CouponFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CouponFormValues>
  ) => {
    const formattedValues = {
      couponCode: values?.coupon_code,
      couponType: values?.coupon_type,
      startDate: values?.vaild_from,
      endDate: values?.valid_till,
      maxAppliedCount: values?.max_apply_count,
      amountType: values?.type,
      maxDiscountAmount:
        values?.maxDiscountAmount === "" ? 0 : values?.maxDiscountAmount,
      student: values?.Student_name?.map((module: any) => module?.value),
      discountAmount: values?.discountAmount,
      startTime: moment(values?.startTime).format("hh:mm A"),
      endTime: moment(values?.endTime).format("hh:mm A"),
    };
    editCoupon({
      body: formattedValues,
      id: couponId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <CouponForm
              formType="Update"
              formikProps={formikProps}
              onClose={onClose}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditCouponFormWrapper;
